/*
    this script applies fading effects to the edges of `overflow: scroll` boxes
    whose content overflows. it will target any container element with the class
    `.js-scroll-container`, which should contain the actual scrollable element with
    class `js-scroll-box`. the script will add its own overlay elements which
    trigger when the box is not fully scrolled to one side.
*/

function scrolled(event, top, bottom, left, right) {
    let height = (event.target.scrollHeight - event.target.clientHeight);
    let scrollV = event.target.scrollTop;

    if (top) {
        if (scrollV <= 0) {
            hide(top);
        } else {
            show(top);
        }
    }

    if (bottom) {
        if (scrollV >= height) {
            hide(bottom);
        } else {
            show(bottom);
        }
    }

    let width = (event.target.scrollWidth - event.target.clientWidth);
    let scrollH = event.target.scrollLeft;
    if (left) {
        if (scrollH <= 0) {
            hide(left);
        } else {
            show(left);
        }
    }

    if (right) {
        if (scrollH >= width) {
            hide(right);
        } else {
            show(right);
        }
    }
}

function show(element) {
    element.classList.add('js-scroll-visible');
}

function hide(element) {
    element.classList.remove('js-scroll-visible');
}

module.exports.init = () => {
    document.querySelectorAll('.js-scroll-container').forEach(container => {
        let top = undefined;
        let bottom = undefined;
        let left = undefined;
        let right = undefined;

        // let bgContainer = container
        // while(window.getComputedStyle(bgContainer).backgroundColor == 'rgba(0, 0, 0, 0)') {
        //     bgContainer = bgContainer.parentNode;
        // }
        // let color = window.getComputedStyle(bgContainer).backgroundColor;

        let overlay = document.createElement('div');
        overlay.classList.add('js-scroll-overlay');

        if(container.classList.contains('js-scroll-vertical')) {
            top = document.createElement('div');
            top.classList.add('js-scroll-top');
            // top.style.background = `linear-gradient(to top, transparent, ${color});`
            overlay.appendChild(top);
            bottom = document.createElement('div');
            bottom.classList.add('js-scroll-bottom');
            // bottom.style.background = `linear-gradient(to bottom, transparent, ${color});`
            overlay.appendChild(bottom);
        }
        if(container.classList.contains('js-scroll-horizontal')) {
            left = document.createElement('div');
            left.classList.add('js-scroll-left');
            // left.style.background = `linear-gradient(to left, transparent, ${color});`
            overlay.appendChild(left);
            right = document.createElement('div');
            right.classList.add('js-scroll-right');
            // right.style.background = `linear-gradient(to right, transparent, ${color});`
            overlay.appendChild(right);
        }

        container.appendChild(overlay);

        let list = container.querySelector('.js-scroll-box');

        list.addEventListener('scroll', event => scrolled(event, top, bottom, left, right));

        // if the content already goes outside the box (which is probably does)
        // this function call will apply the faders where necessary
        scrolled({target: list}, top, bottom, left, right)
    })
}



// WEBPACK FOOTER //
// ./modules/scrollFader.js